import React from "react";
import { UploadStatus } from "../types";

export const STATUS_LABELS: Record<UploadStatus, string> = {
  parsing: "Checking file",
  scheduled: "Scheduled",
  processing: "Reconciling",
  completed: "Completed",
  failed: "Failed",
  rejected: "Invalid",
  canceled: "Canceled",
  reversing: "Reversing",
  reversed: "Reversed",
};

const StatusPill: React.FC<{ status: UploadStatus }> = ({ status }) => (
  <span className={`status ${status}`}>
    <span className="dot" />
    {STATUS_LABELS[status]}
  </span>
);

export default StatusPill;
